import { TRUSTLY_PROVIDER } from 'consts';

// eslint-disable-next-line import/prefer-default-export
export const isTrustlyProvider = (iavProvider) =>
  iavProvider === TRUSTLY_PROVIDER;
